@use 'src/globals/main';

$table-border-color: main.$blue700;
$table-border-active-color: main.$blue700;

$border-width: main.$onepixel;

$border: $border-width solid $table-border-color;

pn-table {
  display: block;
  margin-bottom: 1em;

  .pn-table-container table {
    width: 100%;

    .column-wrapper {
      display: flex;
      gap: 0.5em;
      width: 100%;
      align-items: center;
    }

    &,
    th,
    td {
      padding: 0;
      margin: 0;
      border: 0;
      outline: 0;
      border-collapse: collapse;
      max-width: 100%;
    }

    th,
    td {
      text-align: left;
      line-height: 2;
      vertical-align: middle;
      padding: 1em 1.15em;

      &:first-child {
        border-radius: 0.5em 0 0 0.5em;
      }
      &:last-child {
        border-radius: 0 0.5em 0.5em 0;
      }

      pn-icon {
        vertical-align: middle;
      }
    }

    thead tr {
      th,
      td {
        color: main.$blue700;
        font-weight: 500;
      }
    }

    tbody tr {
      th,
      td {
        color: main.$gray900;
        font-weight: 400;
      }
    }
  }

  &.bordered {
    .pn-table-container table {
      border-collapse: separate;
      border-spacing: 0;

      thead tr {
        &:last-child {
          th,
          td {
            border-bottom-width: $border-width;
          }
        }

        &:first-child {
          th,
          td {
            border-top: $border;
          }
        }

        th,
        td {
          border-bottom: $border;

          &:first-child {
            border-left: $border;
            border-radius: 0.5em 0 0;
          }

          &:last-child {
            border-radius: 0 0.5em 0 0;
            border-right: $border;
          }
        }
      }

      tbody tr {
        th,
        td {
          border-bottom: $border-width solid main.$gray200;

          &:first-child {
            border-left: $border;
            border-radius: 0;
          }

          &:last-child {
            border-right: $border;
            border-radius: 0;
          }
        }

        &:last-of-type {
          th,
          td {
            border-bottom: $border;
          }

          th:last-child,
          td:last-child {
            border-radius: 0 0 0.5em 0;
          }
          th:first-child,
          td:first-child {
            border-radius: 0 0 0 0.5em;
          }
        }
      }
    }

    &.striped .pn-table-container table tbody tr {
      th,
      td {
        border-bottom-width: 0;
      }

      &:last-child {
        th,
        td {
          border-bottom-width: $border-width;
        }
      }
    }
  }

  &.striped .pn-table-container table tbody tr:nth-child(odd) {
    th,
    td {
      background-color: main.$blue25;
    }
  }

  &.color-gray .pn-table-container table tbody tr:nth-child(odd) {
    th,
    td {
      background-color: main.$gray25;
    }
  }
}
